import './NewsPage.css';
import logo from '../assets/whr-logo.png';

interface NewsItem {
  id: string;
  date: string;
  title: { en: string; ru: string; uk: string };
  content: { en: React.ReactNode; ru: React.ReactNode; uk: React.ReactNode };
}

const newsItems: NewsItem[] = [
  {
    id: 'raffle-launch',
    date: '2026-02-06',
    title: {
      en: '🎁 New Feature: Raffles!',
      ru: '🎁 Новая функция: Розыгрыши!',
      uk: '🎁 Нова функція: Розіграші!',
    },
    content: {
      en: (
        <>
          <p>
            Now you can create raffles directly in any Telegram chat! Give away USDT prizes
            to your community with just a few clicks.
          </p>
          <h4>How to use:</h4>
          <ol>
            <li>Type in any chat: <code>@plzpaymebot raffle 100 25.12.2026 18:00</code></li>
            <li>Select the result to create the raffle</li>
            <li>Participants join by clicking the button</li>
            <li>Winner is automatically selected at the scheduled time</li>
            <li>Winner receives a message and enters their TRON address</li>
          </ol>
          <h4>Command formats:</h4>
          <ul>
            <li><code>raffle 100 25.12.2026 18:00</code> — basic raffle for 100 USDT</li>
            <li><code>raffle 50 tomorrow 12:00</code> — tomorrow at noon</li>
            <li><code>raffle 200 +7d</code> — in 7 days at current time</li>
            <li><code>raffle 100 25.12.2026 18:00 "Holiday giveaway!"</code> — with description</li>
            <li><code>raffle 100 25.12.2026 18:00 @mychannel</code> — require subscription</li>
          </ul>
          <h4>Fees:</h4>
          <ul>
            <li>Service fee: 1%</li>
            <li>Network fee: ~0.6 USDT</li>
            <li>Minimum prize: 5 USDT</li>
          </ul>
          <p className="news-note">
            Funds are frozen from your balance when creating the raffle. If cancelled or
            no participants, funds are returned.
          </p>
        </>
      ),
      ru: (
        <>
          <p>
            Теперь вы можете создавать розыгрыши прямо в любом Telegram чате!
            Раздавайте призы в USDT своему сообществу всего в несколько кликов.
          </p>
          <h4>Как использовать:</h4>
          <ol>
            <li>Введите в любом чате: <code>@plzpaymebot raffle 100 25.12.2026 18:00</code></li>
            <li>Выберите результат для создания розыгрыша</li>
            <li>Участники присоединяются по кнопке</li>
            <li>Победитель выбирается автоматически в назначенное время</li>
            <li>Победитель получает сообщение и вводит свой TRON адрес</li>
          </ol>
          <h4>Форматы команд:</h4>
          <ul>
            <li><code>raffle 100 25.12.2026 18:00</code> — розыгрыш на 100 USDT</li>
            <li><code>raffle 50 tomorrow 12:00</code> — завтра в полдень</li>
            <li><code>raffle 200 +7d</code> — через 7 дней</li>
            <li><code>raffle 100 25.12.2026 18:00 "Праздничный розыгрыш!"</code> — с описанием</li>
            <li><code>raffle 100 25.12.2026 18:00 @mychannel</code> — с подпиской на канал</li>
          </ul>
          <h4>Комиссии:</h4>
          <ul>
            <li>Комиссия сервиса: 1%</li>
            <li>Комиссия сети: ~0.6 USDT</li>
            <li>Минимальный приз: 5 USDT</li>
          </ul>
          <p className="news-note">
            Средства замораживаются с вашего баланса при создании розыгрыша. При отмене или
            отсутствии участников средства возвращаются.
          </p>
        </>
      ),
      uk: (
        <>
          <p>
            Тепер ви можете створювати розіграші прямо в будь-якому Telegram чаті!
            Роздавайте призи в USDT своїй спільноті всього за кілька кліків.
          </p>
          <h4>Як використовувати:</h4>
          <ol>
            <li>Введіть у будь-якому чаті: <code>@plzpaymebot raffle 100 25.12.2026 18:00</code></li>
            <li>Оберіть результат для створення розіграшу</li>
            <li>Учасники приєднуються по кнопці</li>
            <li>Переможець обирається автоматично у призначений час</li>
            <li>Переможець отримує повідомлення і вводить свою TRON адресу</li>
          </ol>
          <h4>Формати команд:</h4>
          <ul>
            <li><code>raffle 100 25.12.2026 18:00</code> — розіграш на 100 USDT</li>
            <li><code>raffle 50 tomorrow 12:00</code> — завтра опівдні</li>
            <li><code>raffle 200 +7d</code> — через 7 днів</li>
            <li><code>raffle 100 25.12.2026 18:00 "Святковий розіграш!"</code> — з описом</li>
            <li><code>raffle 100 25.12.2026 18:00 @mychannel</code> — з підпискою на канал</li>
          </ul>
          <h4>Комісії:</h4>
          <ul>
            <li>Комісія сервісу: 1%</li>
            <li>Комісія мережі: ~0.6 USDT</li>
            <li>Мінімальний приз: 5 USDT</li>
          </ul>
          <p className="news-note">
            Кошти заморожуються з вашого балансу при створенні розіграшу. При скасуванні або
            відсутності учасників кошти повертаються.
          </p>
        </>
      ),
    },
  },
];

type Lang = 'en' | 'ru' | 'uk';

function NewsPage() {
  // Detect language from browser
  const browserLang = navigator.language?.substring(0, 2) || 'en';
  const lang: Lang = browserLang === 'uk' || browserLang === 'ru' ? browserLang : 'en';

  const pageTitle = {
    en: '📢 News',
    ru: '📢 Новости',
    uk: '📢 Новини',
  };

  return (
    <div className="news-page-wrapper">
      <header className="news-header">
        <a href="/" className="news-logo-link">
          <img src={logo} alt="Plz Pay Me" className="news-logo" />
          <span className="news-brand">Plz Pay Me</span>
        </a>
      </header>

      <main className="news-page">
        <h1 className="news-page-title">{pageTitle[lang]}</h1>

        <div className="news-list">
          {newsItems.map((item) => (
            <article key={item.id} className="news-item card">
              <div className="news-item-header">
                <time className="news-date" dateTime={item.date}>
                  {new Date(item.date).toLocaleDateString(lang === 'uk' ? 'uk-UA' : lang === 'ru' ? 'ru-RU' : 'en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </time>
              </div>
              <h2 className="news-title">{item.title[lang]}</h2>
              <div className="news-content">{item.content[lang]}</div>
            </article>
          ))}
        </div>
      </main>
    </div>
  );
}

export default NewsPage;
